import * as queryString from 'query-string';

function getQueryParam(name: string, defaultValue = ''): string {
    const search = window?.location?.search;
    return (queryString.parse(search ?? '')[name] as string) ?? defaultValue;
}

export const registerServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/service-worker.js').then(registration => {
                console.log('SW registered: ', registration);

                registration.addEventListener('updatefound', () => {
                    console.log('SW update found: ', registration.scope);
                });

                const updateTimer = () => {
                    setTimeout(() => {
                        registration.update();
                        updateTimer();
                    }, 1000 * 60 * 10); // check for updates every 10 minutes;    
                }
                updateTimer();

            }).catch(registrationError => {
                console.log('SW registration failed: ', registrationError);
            });
        });
    }
}

export const addManifest = async () => {
    const manifestName = `manifest.json`;

    const manifestElement = document.createElement('link');
    manifestElement.setAttribute('rel', 'manifest');

    manifestElement.setAttribute('href', manifestName);

    document.querySelector('head').appendChild(manifestElement);
}

export const runningAsPwa = () => {
    // NOTE: works for Chrome/Android; iOS needs to be handled differently
    let isRunningAsPwa = window.matchMedia('(display-mode: standalone)').matches;

    if (!isRunningAsPwa && getQueryParam('runtime', '') === 'pwa') {
        localStorage.setItem('runtime', 'pwa');
        isRunningAsPwa = true;
    }

    if (!isRunningAsPwa && localStorage.getItem('runtime') === 'pwa') {
        isRunningAsPwa = true;
    }

    return isRunningAsPwa;
}

export const shouldRunAsPwa = () => {
    const forcePwa = getQueryParam('pwa') === 'true';

    return forcePwa;
}

export const cleanupPwa = () => {
    console.log('Cleaning up PWA data...');
    // remove the service worker
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            for (const registration of registrations) {
                console.log('Unregistering service worker:', registration.scope);
                registration.unregister();
            }
        });
    }

    // delete all local storage items
    localStorage.clear();
    sessionStorage.clear();

    // delete all cache objects
    if ('caches' in window) {
        caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
                console.log('Deleting cache:', cacheName);
                caches.delete(cacheName);
            });
        });
    }

    // delete indexDB databases
    if ('indexedDB' in window) {
        const deleteAllDatabases = indexedDB.databases ? indexedDB.databases() : Promise.resolve([]);
        deleteAllDatabases.then(databases => {
            databases.forEach(db => {
                console.log('Deleting IndexedDB database:', db.name);
                indexedDB.deleteDatabase(db.name);
            });
        });
    }

    console.log('PWA data cleanup complete.');
}